export default function padWithZero(number){
  const absNumber = Math.abs(number)
  const paddedNumber =  absNumber.toString().padStart(2, 0)
    
  return number >= 0 ? paddedNumber : `-${paddedNumber}`
}